/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { of, throwError } from "rxjs";
import { AdvancedFilters } from "../../../../models/http/dashboard/advanced-filters.model";
import { ApplicationError } from "../../../../models/ui/application-error.model";
import { HttpRequestOptions } from "../../../../models/ui/http-request-options.model";
import {
	GET_APPS_PERFORMANCE_RESPONSE,
	GET_TOTAL_CO2_RESPONSE,
	GET_WORST_10_APPS_RESPONSE,
	GET_WORST_10_LAYERS_RESPONSE
} from "./dashboard-energy.db";

const CLASS_NAME = "DashboardEnergy";

export class DashboardEnergy {
	public static getAppsPerformance(options: HttpRequestOptions) {
		const filters = options.body as AdvancedFilters | undefined;

		if (!filters?.startDate || !filters.endDate)
			return throwError(
				() =>
					new ApplicationError(
						"Missing required parameters",
						CLASS_NAME,
						"getAppsPerformance"
					)
			);

		return of(GET_APPS_PERFORMANCE_RESPONSE);
	}

	public static getTotalCo2(options: HttpRequestOptions) {
		const filters = options.body as AdvancedFilters | undefined;

		if (!filters?.startDate || !filters.endDate)
			return throwError(
				() => new ApplicationError("Missing required parameters", CLASS_NAME, "getTotalCo2")
			);

		return of(GET_TOTAL_CO2_RESPONSE);
	}

	public static getWorst10Apps(options: HttpRequestOptions) {
		const filters = options.body as AdvancedFilters | undefined;

		if (!filters?.startDate || !filters.endDate)
			return throwError(
				() =>
					new ApplicationError(
						"Missing required parameters",
						CLASS_NAME,
						"getWorst10Apps"
					)
			);

		return of(GET_WORST_10_APPS_RESPONSE);
	}

	public static getWorst10Layers(options: HttpRequestOptions) {
		const filters = options.body as AdvancedFilters | undefined;

		if (!filters?.startDate || !filters.endDate)
			return throwError(
				() =>
					new ApplicationError(
						"Missing required parameters",
						CLASS_NAME,
						"getWorst10Layers"
					)
			);

		return of(GET_WORST_10_LAYERS_RESPONSE);
	}
}
